/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { VDP_CONSTS } from "./vdp-constants";

export interface IUserRPC {
   command: number | string;
   type: any;
   params: number | Uint8Array[];
   toCompress: boolean;
   object?: {
      id: number;
      name: string;
   };
   objID?: number;
   objName: string;
   onDone: IRPC;
   onAbort: IRPC;
}

export interface IRPC {
   command: number | string;
   action: number;
   contexts: number[];
   params: (number | string | Uint8Array)[];
   returnCode: number;
   returnParams: (number | string | Uint8Array)[];
   abort: number;
   userCancelled: number;
   abortCode: number;
   type: string;
}
